import React, { useState, useContext, useEffect } from 'react';
import { Col, Form, Row, DatePicker, Tabs, Modal, Card, Button } from 'antd';
import moment from 'moment'
import PageContainer from '../../../CSIComponents/PageContainer';
import { isEditStateContext, isSaveContext } from '../../../../store/editableContext'
import { post, getData } from '../apiCalls'
const { TabPane } = Tabs;

declare global {
  interface Window {
    otherAmenitiesHotelBody: {
      startdate: string,
      enddate: string
    },
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    },
  }
}

const Hotel = () => {

  const dateFormat = 'MM/DD/YYYY';
  const datePickerComponent = (activeKey: string | number) => {
    return (
      <Form
      layout="vertical"
      name="basic"
      initialValues={{
        "startDatePicker": window.otherAmenityGet?.closures[activeKey] && [moment(window.otherAmenityGet?.closures?.[activeKey].startdate), moment(window.otherAmenityGet?.closures?.[activeKey].enddate)]
      }}
      >
        <Row gutter={12}>
          <Col span={8}>
            <Form.Item
            name={'startDatePicker'}
            label="Start Date ~ End Date"
            rules={[{required: true, message: 'This field is required'}]}
            >
              <DatePicker.RangePicker
              key={activeKey}
              format={dateFormat}
              onChange={(e: any) => onChageDate(e, activeKey, 'rangePicker')} 
              />
            </Form.Item> 
          </Col>
        </Row>
      </Form>
    )
  }

  const onChageDate = (value: string, index: any, type: string) => {
    switch (type) {
      case 'rangePicker': 
        const tempArrayStart = dates
        const tempObjStart = {
          'startdate': moment(value?.[0]).format('MM/DD/YYYY'),
          'enddate': moment(value?.[1]).format('MM/DD/YYYY')
        }
        tempArrayStart[index] = tempObjStart
        return setDate(tempArrayStart)
      default:
        return false
    }
  }
  
  const context = useContext(isEditStateContext)
  const saveContext = useContext(isSaveContext)
  const [ready, setReady] = useState<boolean>(false)
  const [activeKey, setActiveKey] = useState("1")
  const [panes, setPanes] = useState<any>([])
  const [viewOrEdit, setViewOrEdit] = useState(1);
  const [dates, setDate] = useState<any>([])
  const onChange = (activeKey: string) => {
    setActiveKey(activeKey);
  };

  const onEdit = (targetKey: any, action: any) => {
      if (action === 'add') {
          add()
      } else if (action === 'remove') {
          remove(targetKey)
      }
  };

  const add = () => {
    const activeKey = `newTab${panes.length}`;
    const newPanes = [...panes];
    newPanes.push({ title: 'New Tab', content: datePickerComponent(panes.length), key: activeKey });
    setPanes(newPanes);
    setActiveKey(activeKey);
  };

  const ModalHead = () => {
    return (
        <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '50px',
            lineHeight: '50px',
            textIndent: '10px',
            borderBottom: '1px solid #ccc',
            color: '#fff',
            background: '#06789D',
            fontSize: 18,
            width: '100%'
        }}>Confirm</div>
    )
}

  const remove = (targetKey: any) => {
    // let deleteTabName = curTagdata.filter((item: any) => targetKey == item.amenityid)
    Modal.confirm({
        title: <ModalHead />,
        centered: true,
        icon: '',
        content: `Are you sure you want to delete  ?`,
        cancelText: 'Cancel',
        okText: 'Delete',
        onOk() {
          let newActiveKey = activeKey;
          let lastIndex;
          panes.forEach((pane: any, i: number) => {
            if (pane.key === targetKey) {
              lastIndex = i - 1;
              dates.splice(i, 1)
            }
          });
          const newPanes = panes.filter((pane: any) => pane.key !== targetKey);
          if (newPanes.length && newActiveKey === targetKey) {
            if (lastIndex && lastIndex >= 0) {
              newActiveKey = newPanes[lastIndex].key;
            } else {
              newActiveKey = newPanes[0].key;
            }
          }
          setPanes(newPanes);
          setActiveKey(activeKey);
        },
        onCancel() { },
    });
  }

  const editStart = (values: any) => {
    setViewOrEdit(2)
    window.editFunction();
  };

  const editButton = (
      <Button 
      type="primary" 
      htmlType="submit" 
      onClick={editStart} 
      className='DSbtn_edit'
      style={{ display: viewOrEdit === 1 ? 'block' : 'none' }}>
        Edit
      </Button>
  )

  const saveAction = async () => {
    window.otherAmenitiesHotelBody = dates
    await post()
    await getData()
  }

  const composite = async (obj: object) => {
    const tempPanes: object[] = []
    const cloneObj = JSON.parse(JSON.stringify(obj))
    await cloneObj.map((item: any, index: number) => {
      item = {
        ...item,
        title: '',
        content: datePickerComponent(index),
        key: `newTab${index}`,
        closable: true,
      }
      return tempPanes.push(item)
    })
    setPanes(tempPanes)
    setDate(obj)
    setReady(true)
  }

  const watcher = async () => {
    // save button functionality for other amenities
    const saveBtn: any = document.querySelectorAll('[data-test="save-btn"]')
    const startDateFields: any = document.querySelectorAll('#basic_startdate')
    const endDateFields: any = document.querySelectorAll('#basic_enddate')
    for (let i = 0; i < startDateFields.length; i++) {
      if (startDateFields[i].value === '' || endDateFields[i].value === '' ) {
        for (let i = 0; i < saveBtn.length; i++) {
          return saveBtn[i]?.classList?.add("is-disabled")
        }
      }
    } 
  }

  useEffect(() => {
    // adding listeners
    const get = async () => {
      // adding listeners
      window.addEventListener('input', async () => { await watcher() })
      window.addEventListener('change', async () => { await watcher() })
      window.addEventListener('click', async () => { await watcher() })
      window.addEventListener('mousemove', async () => { await watcher() })
      window.addEventListener('keydown', async () => { await watcher() })
      if (window.otherAmenityGet?.closures.length <= 0) {
        add()
        const activeKeyAdd = `newTab0`;
        setActiveKey(activeKeyAdd);
        const body = [{ title: 'New Tab', content: '', key: activeKeyAdd }]
        composite(body)
      } else {
        composite(window.otherAmenityGet ? window.otherAmenityGet.closures : [])
      }
    }
    get()
    return () => {
      // on unmount removing events
      window.removeEventListener('input', async () => { await watcher() })
      window.removeEventListener('change', async () => { await watcher() })
      window.removeEventListener('click', async () => { await watcher() })
      window.removeEventListener('mousemove', async () => { await watcher() })
      window.removeEventListener('keydown', async () => { await watcher() })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    if (saveContext) {
      saveAction()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saveContext])

  useEffect(() => {
    if (!context) {
      // removing action buttons
      setViewOrEdit(1)
    }
  },[context])

  useEffect(() => {
    if (viewOrEdit === 2) {
      switch (!!window.otherAmenityGet?.closures.length) {
        case false:
          if (!(!!panes.length)) add()
          const activeKeyAdd = `newTab0`;
          setActiveKey(activeKeyAdd);
          break;
        default:
          composite(window.otherAmenityGet ? window.otherAmenityGet.closures : [])
          // set active tab the latest
          const activeKey = `newTab${panes.length - 1}`;
          setActiveKey(activeKey);
          break;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[viewOrEdit])

  return (
    <>
      { ready ?
        <PageContainer>
          <Card className="col-12">
            { viewOrEdit === 1 ?
              <Tabs
              onChange={onChange}
              type="card"
              tabBarExtraContent={editButton}
            >
              {panes.map((pane: any, i: number) => (
                <TabPane
                  tab={`Hotel Closure ${i + 1}`}
                  key={pane.key}
                  closable={pane.closable || true}
                  className="is-disabled-fields"
                >
                  {pane.content}
                </TabPane>
              ))}
            </Tabs>
            :
              <Tabs
                type="editable-card"
                onChange={onChange}
                activeKey={activeKey}
                onEdit={onEdit}
              >
                {panes.map((pane: any, i: number) => (
                  <TabPane
                    tab={`Hotel Closure ${i + 1}`}
                    key={pane.key}
                    closable={pane.closable || true}
                  >
                    {pane.content}
                  </TabPane>
                ))}
              </Tabs>
            }
        </Card>
      </PageContainer>
      : <></>}
    </>
  )
}

export default Hotel
